import type { ReactNode } from 'react';

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  actions?: ReactNode;
  /** Content rendered centered between the title and actions (same row). */
  centerContent?: ReactNode;
  /** Action rendered immediately after the title block (before center content). */
  leftAction?: ReactNode;
  icon?: ReactNode;
}

/** @deprecated Use PageLayout from '@/lib/base/page-layout/page-layout' instead. */
export default function PageHeader({
  title,
  subtitle,
  actions,
  centerContent,
  leftAction,
  icon,
}: PageHeaderProps) {
  return (
    <div className='flex flex-wrap justify-between items-center gap-2 mb-2 md:mb-6'>
      {icon ? (
        <div className='grid grid-cols-[auto_1fr] gap-x-3'>
          {/* Icon centered in row; title stays at top to align with action buttons */}
          <div className='self-center'>{icon}</div>
          <h1 className='col-start-2 text-lg md:text-2xl font-semibold text-fg-primary'>
            {title}
          </h1>
          {subtitle && (
            <p className='row-start-2 col-start-2 text-sm text-secondary'>
              {subtitle}
            </p>
          )}
        </div>
      ) : (
        <div>
          <h1 className='text-lg md:text-2xl font-semibold text-fg-primary'>
            {title}
          </h1>
          {subtitle && <p className='text-sm text-secondary'>{subtitle}</p>}
        </div>
      )}
      {leftAction && <div className='flex items-center'>{leftAction}</div>}
      {centerContent && (
        <div className='flex items-center justify-center'>{centerContent}</div>
      )}
      {actions && <div className='flex items-center gap-3'>{actions}</div>}
    </div>
  );
}
